import { Component, HostListener, Input, OnInit } from '@angular/core';
import { UtilService } from '@app/shared/utils';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  @Input() tabindex: number;

  get isFooter(): boolean {
    const urls = ['motor-relatorio','gestao-de-caixa', 'boleta-upload', 'ocultacaocda'];
    const isUrl = urls.find((item: string) => window.location.href.includes(item));
    return !isUrl
  }

  constructor(private util: UtilService) {}

  public ngOnInit(): void {
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.calculateMinHeight();
    window.addEventListener(
      'resize',
      () => {
        const offset: number = 218;
        const temporaryAdditionalOffset: number = 45;
        let height = window.innerHeight;
        let body: Element = document.getElementsByClassName('page-container')[0];
        if (body) {
          let bodyHeight: number = body.getBoundingClientRect().height;
          if (height > bodyHeight) {
            body.setAttribute('style', `min-height: ${height + temporaryAdditionalOffset - offset}px;`);
          }
        }
      },
      false
    );
  }

  calculateMinHeight() {
    const offset: number = 218;
    const temporaryAdditionalOffset: number = 45;
    let height = window.innerHeight;
    let body: Element = document.getElementsByClassName('page-container')[0];
    if (body) {
      let bodyHeight: number = body.getBoundingClientRect().height;

      if (height > bodyHeight) {
        const disclaimerHeight = 75;
        let value = height + temporaryAdditionalOffset - offset;
        if (this.util.isHomePageOrBrowserWarning()) {
          value = value - disclaimerHeight;
        }
        body.setAttribute('style', `min-height: ${value}px`);
      }
    }
  }

  goToHeader() {
    this.util.requestFocus('headerArea');
    //this.util.requestFocus("itau_logo");
  }
}
